import { FC } from "react";

interface MoreSvgProps {
  variant?: "filled" | "outlined";
}

const MoreSvg: FC<MoreSvgProps> = ({ variant = "filled" }) => {
  if (variant === "outlined") {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5024 11.9983C18.5024 12.2745 18.2784 12.4985 18.0022 12.4985C17.7259 12.4985 17.502 12.2745 17.502 11.9983C17.502 11.722 17.7259 11.498 18.0022 11.498C18.2784 11.498 18.5024 11.722 18.5024 11.9983"
          stroke="#323232"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4985 11.9983C12.4985 12.2745 12.2745 12.4985 11.9983 12.4985C11.722 12.4985 11.498 12.2745 11.498 11.9983C11.498 11.722 11.722 11.498 11.9983 11.498C12.2745 11.498 12.4985 11.722 12.4985 11.9983"
          stroke="#323232"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.49651 11.9983C6.49651 12.2745 6.27256 12.4985 5.9963 12.4985C5.72004 12.4985 5.49609 12.2745 5.49609 11.9983C5.49609 11.722 5.72004 11.498 5.9963 11.498C6.27256 11.498 6.49651 11.722 6.49651 11.9983"
          stroke="#323232"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16667 11.6663C5.08714 11.6663 5.83333 10.9201 5.83333 9.99967C5.83333 9.0792 5.08714 8.33301 4.16667 8.33301C3.24619 8.33301 2.5 9.0792 2.5 9.99967C2.5 10.9201 3.24619 11.6663 4.16667 11.6663Z"
        fill="black"
      />
      <path
        d="M9.99967 11.6663C10.9201 11.6663 11.6663 10.9201 11.6663 9.99967C11.6663 9.0792 10.9201 8.33301 9.99967 8.33301C9.0792 8.33301 8.33301 9.0792 8.33301 9.99967C8.33301 10.9201 9.0792 11.6663 9.99967 11.6663Z"
        fill="black"
      />
      <path
        d="M15.8337 11.6663C16.7541 11.6663 17.5003 10.9201 17.5003 9.99967C17.5003 9.0792 16.7541 8.33301 15.8337 8.33301C14.9132 8.33301 14.167 9.0792 14.167 9.99967C14.167 10.9201 14.9132 11.6663 15.8337 11.6663Z"
        fill="black"
      />
    </svg>
  );
};

export default MoreSvg;
